/**
 * Converts an item's answerKeys such as 'answer0001' to letters for display.
 * @param {integer} itemNumber the number of the test item (index + 1 usually).
 * @param {string} answerKey the answer string from db, such as 'answer0001'.
 * @returns {string} A letter (ABCDE or FGHJK). 
 */
export default function convertToAnswerLetters(itemNumber, answerKey) {
  const translator = {
    odd: {
      answer0000: 'A',
      answer0001: 'B',
      answer0002: 'C',
      answer0003: 'D',
      answer0004: 'E',
    },
    even: {
      answer0000: 'F',
      answer0001: 'G',
      answer0002: 'H',
      answer0003: 'J',
      answer0004: 'K',
    }
  }

  let oddOrEven = 'odd'
  if (itemNumber % 2 === 0) {
    oddOrEven = 'even'
  }

  const answer = translator[oddOrEven][answerKey]

  return answer
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/convertToAnswerLetters.js